import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from 'reactstrap';
import Swal from 'sweetalert2';
import { deleteCertificateAPI, deleteFrameworkAPI, getSingleCertificateAPI, getSingleframeworkAPI } from '../../../apiConfig/apiCall';
import dummyUserImage from '../../../assets/images/users/user-dummy-img.jpg';
import { getCertificationList } from '../../../slices/ManageCompliance/manageComplianceSlice';
// import addFrameworkModal from './addFrameworkModal';
// import frameworkPointsModal from './frameworkPointsModal';
// import ProfileSelector from './ImageSetter/ProfileSelector';
// import uploadFrameworkModal from './uploadFrameworkModal';
import BasicTable from '../../ReactTable/BasicTable';
import AddFrameworkModal from './AddFrameworkModal';
import UploadFrameworkModal from './UploadFrameworkModal';
import FrameworkPointsModal from './FrameworkPointsModal';

const FrameworksTable = ({ data, refreshComponent }) => {

    const dispatch = useDispatch();

    const API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL_2;

    const [filtering, setFiltering] = useState('');
    const [pageSize, setPageSize] = useState(10);

    // Upload User Profile Image Logic
    const [userProfileImgUploadModal, setUserProfileImgUploadModal] = useState(false);
    const [currentToggledUserProfileImgUrl, setCurrentToggledUserProfileImgUrl] = useState('');
    const [currentUserSsoIdForEditProfile, setCurrentUserSsoIdForEditProfile] = useState('');
    const toggleUserProfileImgUploadModal = (imagePath, SSO_ID) => {
        console.log(SSO_ID)
        setCurrentToggledUserProfileImgUrl(imagePath);
        setCurrentUserSsoIdForEditProfile(SSO_ID);
        setUserProfileImgUploadModal(!userProfileImgUploadModal);
    }

    const columns = [
        {
            header: "S.No",
            accessorKey: "id",
            cell: ({ row }) => (
                <span className="fw-semibold">{row.index + 1}</span>
            ),
            enableSorting: false,
        },
        {
            header: "Framework Name",
            accessorKey: "frameworkName",
        },
        {
            header: "Framework Original Name",
            accessorKey: "frameworkOriginalName",
        },
        {
            header: "Status",
            accessorKey: "status",
            cell: ({ row }) => (
                <span
                    style={{
                        color: row.original.status === 'ACTIVE' ? 'green' : 'red',
                    }}
                >
                    {row.original.status}
                </span>
            ),
        },
        {
            header: "Entry Date",
            accessorKey: "entryDate",
        },
        {
            header: "Actions",
            accessorKey: "actions",
            cell: ({ row }) => (
                <div className="d-flex gap-2">

                    <div
                        onClick={() => handleDelete(row.original.id)}
                        className="text-danger bg-danger-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="bx bxs-trash-alt"></i>
                    </div>

                    <div
                        onClick={() => handleViewframeworkPoints(row.original.id)}
                        className="text-info bg-info-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="ri-list-unordered"></i>
                    </div>
                </div>
            ),
            enableSorting: false,
        },
    ];

    // Add Certificate Logic
    const [addFrameworkModal, setAddFrameworkModal] = useState(false);
    const [uploadFrameworkModal, setUploadFrameworkModal] = useState(false);

    const toggleAddFrameworkModal = () => setAddFrameworkModal(!addFrameworkModal);
    const toggleUploadFrameworkModal = () => setUploadFrameworkModal(!uploadFrameworkModal);


    // Delete Certificate Logic
    const handleDelete = (id) => {
        Swal.fire({
            width: '20rem',
            padding: '0 0 1rem 0',
            title: "Are you sure?",
            text: `You won't be able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteFrameworkAPI(id)
                    .then(response => {
                        Swal.fire({
                            title: "Deleted!",
                            text: response.data,
                            icon: "success",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                        refreshComponent();
                    })
                    .catch(error => {
                        Swal.fire({
                            title: "Error!",
                            text: error,
                            icon: "error",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                    });
            }
        });
    };


    // Cerification Points Modal
    const [frameworkType, setframeworkType] = useState('');
    const [frameworkVersion, setframeworkVersion] = useState('');
    const [frameworkPoints, setframeworkPoints] = useState('');

    const [frameworkPointsModal, setframeworkPointsModal] = useState(false);
    const toggleframeworkPointsModal = () => setframeworkPointsModal(!frameworkPointsModal);


    const [cvId, setCvId] = useState();

    const handleViewframeworkPoints = async (certificationID) => {
        setframeworkPointsModal(true);

        const apiResponse = await getSingleframeworkAPI(certificationID);
        if (apiResponse.status === 200) {
            setframeworkType(apiResponse.data.frameworkType);
            setframeworkVersion(apiResponse.data.frameworkVersion);
            setframeworkPoints(apiResponse.data.frameworkCommands)
            setCvId(apiResponse.data.id);
        }
    }

    return (
        <>

            <Card>
                <CardHeader className="border-0 py-1">
                    <Row>
                        <Col lg={6} className='d-flex align-items-center'>
                            <h5 className="card-title mb-0">Frameworks List</h5>
                            <ButtonGroup className="material-shadow ms-2">
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        tag="button"
                                        className="btn p-1 btn-sm btn-light material-shadow-none"
                                        style={{
                                            fontSize: '.7rem',
                                        }}
                                    >
                                        {pageSize} <i className="mdi mdi-chevron-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu style={{ minWidth: '100%' }}>
                                        {[10, 20, 50, 100].map((size) => (
                                            <DropdownItem
                                                key={size}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '0.2rem',
                                                    fontSize: '.7rem',
                                                }}
                                                onClick={() => setPageSize(size)}
                                            >
                                                {size}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </ButtonGroup>
                        </Col>
                        <Col lg={6} className='d-flex'>
                            <input
                                className="form-control me-2"
                                type="text"
                                placeholder="Search..."
                                value={filtering}
                                onChange={(e) => setFiltering(e.target.value)}
                                style={{
                                    height: '28px',
                                    fontSize: '.7rem',
                                    borderRadius: '.2rem',
                                }}
                            />
                            <Button
                                type="button"
                                className="btn-sm btn-success me-2"
                                onClick={toggleAddFrameworkModal}
                                style={{
                                    width: '100%',
                                    height: '28px',
                                    fontSize: '.7rem',
                                    borderRadius: '.2rem',
                                }}
                            >
                                <i className="ri-add-line align-bottom me-1"></i>
                                Add Framework
                            </Button>
                            <Button
                                type="button"
                                className="btn-sm btn-success"
                                onClick={toggleUploadFrameworkModal}
                                style={{
                                    width: '100%',
                                    height: '28px',
                                    fontSize: '.7rem',
                                    borderRadius: '.2rem',
                                }}
                            >
                                <i className="ri-upload-line align-bottom me-1"></i>
                                Upload Framework
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>


                <CardBody className="border border-dashed border-end-0 border-start-0">
                    <BasicTable
                        columns={columns}
                        data={data}
                        customPageSize={pageSize}
                        filtering={filtering}
                        setFiltering={setFiltering}
                    />
                </CardBody>
            </Card>

            {/* Add Framework Modal */}
            <AddFrameworkModal
                addFrameworkModal={addFrameworkModal}
                setAddFrameworkModal={setAddFrameworkModal}
                toggleAddFrameworkModal={toggleAddFrameworkModal}
                refreshComponent={refreshComponent}
            />

            {/* Upload Framework Modal */}
            <UploadFrameworkModal
                uploadFrameworkModal={uploadFrameworkModal}
                setUploadFrameworkModal={setUploadFrameworkModal}
                toggleUploadFrameworkModal={toggleUploadFrameworkModal}
                refreshComponent={refreshComponent}
            />

            {/* Framework Points Modal */}
            <FrameworkPointsModal
                frameworkPointsModal={frameworkPointsModal}
                toggleframeworkPointsModal={toggleframeworkPointsModal}
                frameworkType={frameworkType}
                frameworkVersion={frameworkVersion}
                frameworkPoints={frameworkPoints}
                setframeworkPoints={setframeworkPoints}
                cvId={cvId}
            />

        </>
    );
};

export default FrameworksTable;